import React, { useState, useEffect, useRef } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

// Icons
import { MdMyLocation } from "react-icons/md";
import PinIcon01 from "../../assets/icons/mapIcon01.png";
import PinIcon02 from "../../assets/icons/mapIcon02.png";
import { browSer } from "../../helper/constant";
import "./style.css";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

const GoogleMaps = ({
                        google,
                        latitude,
                        longitude,
                        onMarkerDragEnd,
                        onMyLocation,
                        fetchAddress,
                        onMapZoom,
                        type,
                        addressDetails,
                        setLatLng
                    }) => {
    const classes = useStyles();

    // Separate states for map center and marker position.
    const [center, setCenter] = useState({ lat: 11.585059400964562, lng: 104.91634500155044 });
    const [markerPosition, setMarkerPosition] = useState({ lat: 11.585059400964562, lng: 104.91634500155044 });
    const [isDragging, setIsDragging] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [mapZoom, setMapZoom] = useState(15);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const handleToggleError = (message = "") => {
        setErrorMessage(message);
        setShowError(!showError);
    };


    // Clicking on the map updates the marker's position without changing the map's center.
    const handleMarkerDragStart = () => {
        setIsDragging(true);
    };

    const handleMapDragEnd = (mapProps, map) => {
        const newPosition = {
            lat: map.center.lat(),
            lng: map.center.lng(),
        };
        setMarkerPosition(newPosition);
        setIsDragging(false);
        setMarkerPosition(newPosition);
        onMarkerDragEnd(mapProps, newPosition);
    };
    const handleDragStart = () => {
        setIsDragging(true);
    };


    const handleMarkerDragEnd = (mapProps, map, clickEvent) => {
        const newPosition = {
            lat: clickEvent.latLng.lat(),
            lng: clickEvent.latLng.lng(),
        };
        setMarkerPosition(newPosition);
        setIsDragging(false);
        setMarkerPosition(newPosition);
        onMarkerDragEnd(mapProps, newPosition);
    };


    // Clicking on the map updates the marker's position without changing the map's center.
    const handleMapClick = (mapProps, map, clickEvent) => {
        const newPosition = {
            lat: clickEvent.latLng.lat(),
            lng: clickEvent.latLng.lng(),
        };
        setMarkerPosition(newPosition);
        onMarkerDragEnd(mapProps, newPosition);
    };
    // Get the current location of the user.
    const handleGetCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const newLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    onMyLocation(position, newLocation);
                    setMapZoom(20);
                    // Set both the map center and marker position.
                    setCenter(newLocation);
                    setMarkerPosition(newLocation);
                    setLatLng(newLocation)
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    defaultPosition();
                },
                { enableHighAccuracy: true, maximumAge: 0, timeout:5000 }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

    const defaultPosition = () => {
        if (browSer() === "Chrome") {
            if (
                window.location.hostname === "development.d3ibyqsz1idneb.amplifyapp.com"
            ) {
                handleToggleError(
                    "Location permissions not allowed for Google Chrome, allow your location by following this link in another tab 'chrome://settings/content/siteDetails?site=https://development.d3ibyqsz1idneb.amplifyapp.com/', set it to 'Ask' and reload the page"
                );
            } else {
                handleToggleError(
                    "Location permissions not allowed for Google Chrome, allow your location by following this link in another tab 'chrome://settings/content/siteDetails?site=https://delishop.asia/', set it to 'Ask' and reload the page"
                );
            }
        } else if (browSer() === "Safari") {
            if (
                window.location.hostname === "development.d3ibyqsz1idneb.amplifyapp.com"
            ) {
                handleToggleError(
                    "Location permissions not allowed for Safari, allow your location by following these steps : \nSafari -> Preferences -> Websites tab -> Location -> development.d3ibyqsz1idneb.amplifyapp.com -> ask and reload the page"
                );
            } else {
                handleToggleError(
                    "Location permissions not allowed for Safari, allow your location by following these steps : \nSafari -> Preferences -> Websites tab -> Location -> delishop.asia -> ask and reload the page"
                );
            }
        }
    };


    useEffect(() => {
        if(latitude && longitude) {
            const initialPos = {lat: latitude, lng: longitude};
            setCenter(initialPos);
            setMarkerPosition(initialPos);
        }
    }, [latitude, longitude]);

    useEffect(() => {
        fetchAddress();
    }, []);

    // Hide loading spinner when the map is ready.
    const onMapLoaded = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        if (type === "create" && !latitude && !longitude) {
            handleGetCurrentLocation();
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            {/* Pre-loading Spinner */}
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <div
                style={{
                    width: "100%",
                    paddingTop: "10px",
                    marginBottom: "10px",
                    height: "58vh",
                    position: "relative",
                    zIndex: 10,
                }}
            >
                {/* Custom Animated Pin (ALWAYS centered) */}
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -100%)", // Adjusts to keep the pin in the center
                        zIndex: 100, // Ensure this is above the map
                        // animation: isDragging ? "bounce 0.5s infinite" : "none",
                    }}
                >
                    {/* Label above the pin */}
                    {isDragging && (
                        <div>
                            <div
                                style={{
                                    backgroundColor: "#9cc54b",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    padding: "2px 12px",
                                    textAlign: "center",
                                    marginBottom: "-50px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Looking for address...
                            </div>
                            <img
                                alt={"pinMap"}
                                src={PinIcon01}
                                style={{
                                    color: "#e31414",
                                    marginLeft: "67px",
                                    marginTop: "55px",
                                    width: "55px",
                                }}
                            />
                        </div>
                    )}
                </div>

                <Map
                    streetViewControl={false}
                    mapTypeControl={true}
                    keyboardShortcuts={true}
                    scrollwheel={true}
                    center={center}
                    google={google}
                    style={{
                        width: "100%",
                        height: "100%",
                    }}
                    zoom={mapZoom}
                    initialCenter={center}
                    fullscreenControl={false}
                    draggable={true}
                    onReady={onMapLoaded}
                    onClick={handleMapClick}
                    onDragstart={handleDragStart} // ✅ Change icon when dragging starts
                    onDragend={(t, map) => handleMapDragEnd(t, map)}
                >
                    {!isDragging && <Marker
                        position={markerPosition}
                        draggable={true}
                        onDragStart={handleMarkerDragStart}
                        onDragend={(t, map, coord) => handleMarkerDragEnd(t, map, coord)}
                        icon={{
                            url: PinIcon01,
                            scaledSize: new google.maps.Size(55, 55),
                        }}
                        label={{
                            text: "Your delivery address" || "...",
                            color: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "bold",
                            className: "custom-marker-label",
                        }}
                    />}
                </Map>

                {/* Current Location Button */}
                <div
                    onClick={handleGetCurrentLocation}
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "20px",
                        zIndex: 101,
                        backgroundColor: "#9cc54b",
                        color: "#fff",
                        border: "none",
                        padding: "10px",
                        borderRadius: "50%",
                        cursor: "pointer",
                    }}
                >
                    <MdMyLocation style={{ fontSize: "30px" }} />
                </div>
            </div>

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={showError}
                onClose={() => handleToggleError("")}
                message={errorMessage}
                autoHideDuration={4000}
                key="center-center" // ✅
                style={{ fontSize: "35px" }}
                // ContentProps={{
                //     style: {
                //         marginTop: "50px"
                //     },
                // }}
            />
        </>
    );
};

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    libraries: ["places"],
})(GoogleMaps);
